import { render, staticRenderFns } from "./TheTableTowns.vue?vue&type=template&id=9a058b1e&scoped=true&"
import script from "./TheTableTowns.vue?vue&type=script&lang=ts&"
export * from "./TheTableTowns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a058b1e",
  null
  
)

export default component.exports